import { IValidationRule } from "@/types"

const costCategoryValidationRules: { [s: string]: IValidationRule } = {
    costCategoryType: {
        required: true,
    },
    costCategoryName: {
        required: true,
    },
    costCategoryLedgerAccount: {
        required: true,
    },
    automaticAssignLimit:{
        type:'decimal',
        gt:0
    },
    distributionRule:{
        required:true
    }
}

export default costCategoryValidationRules
